import { FC } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import style from './style.module.css';

interface IPageCard {
  title: React.ReactNode
  children: React.ReactNode
  extra?: React.ReactNode
}

const PageCard: FC<IPageCard> = ({ title, children, extra }) => {
  return (
    <Card className={style.card}>
      <CardHeader className={extra ? "flex flex-row items-center justify-between space-y-0" : undefined}>
        <CardTitle>{title}</CardTitle>
        {extra}
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  )
}

export default PageCard;
